<template>
  <div class="footer">
    @2015 Yoxnet 北京悦享互联技术有限公司<a href="https://beian.miit.gov.cn">京ICP备15029089号</a>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
    props: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer {
    padding: 2rem;
    text-align: center;
    color: #fff;
    font-size: 14px;
    background: #202225;
  }
</style>
